import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { SinvoiceLine } from './s-invoice-line';
import { SalesTransactionPromoDetail } from './sales-transaction-promo-detail';
import { Sorder } from './s-order';

export class Sinvoice extends BaseEntity {
  
  sinvoiceCode        : string;
  partner             : Partner;
  periodActiveDay     : Date;
  discount            : number;
  amount              : number;

  sorder              : Sorder;
  sinvoiceLines                 : SinvoiceLine[] = [];
  salesTransactionPromoDetails  : SalesTransactionPromoDetail[] = [];

  constructor() {
    super()
  }
 
}
 


